import dayjs from 'dayjs';

interface Params {
    timeFromNow: number;
    blockHeight: string;
}

const DATE_FORMAT = 'YYYYMMDDTHHmm';

export default function createGoogleCalendarLink({timeFromNow, blockHeight}: Params): string {
    const date = dayjs().add(timeFromNow, 's');
    const name = `Block #${blockHeight} reminder | ${process.env.REACT_APP_BASE_UNIT}`;
    const description = `#${blockHeight} block creation time on ${process.env.REACT_APP_BASE_UNIT} blockchain.`;
    const startTime = date.format(DATE_FORMAT);
    const endTime = date.add(15, 'minutes').format(DATE_FORMAT);
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const blockUrl = `${process.env.REACT_APP_BASEURL}/block/${blockHeight}`;

    const url = new URL('calendar/render', 'https://www.google.com/');
    url.searchParams.append('action', 'TEMPLATE');
    url.searchParams.append('text', name);
    url.searchParams.append('details', description + '\n' + blockUrl);
    url.searchParams.append('dates', `${startTime}/${endTime}`);
    url.searchParams.append('ctz', timeZone);

    return url.toString();
}
